module.exports = __webpack_public_path__ + "static/media/tennisballen.16e00f7d.jpg";